"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.support = void 0;
exports.support = {
    support_title: "Поддержка",
    support_chooseRequestType: "Тема вашего обращения",
    support_requestTypeLittered: "Территория захламлена",
    support_requestTypeOverfilled: "Контейнер переполнен",
    support_requestTypeAdd: "Хочу РСО у себя в многоквартирном доме",
    support_requestTypeOther: "Прочее",
    support_text: "Текст сообщения",
    support_submit: "Отправить обращение",
    support_policyAccept: "Я соглашаюсь на обработку моих персональных данных и ознакомлен(а) с условиями",
    support_policyLink: "политики конфиденциальности",
    support_policyError: "Вы должны принять условия",
    support_finishTitle: "Спасибо!",
    support_finishMessage: "В ближайшее время мы рассмотрим ваше обращение",
    support_email: "Электронная почта для обращений граждан",
    support_litteredPlaceholder: "Опишите: например, навалены остатки кустов, деревьев, ТБО или строительный мусор",
};
//# sourceMappingURL=support.js.map